// src/api/admin/adminApi.js
import api from '../axiosInstance';
import { ensureCsrfToken } from '../utils/csrfUtils';


// 유저 상세 조회
export const getUserById = async (userId) => {
  console.log(`[adminApi] 유저 상세 조회 API 호출 - userId: ${userId}`);
  const res = await api.get(`/api/admin/user/detail/${userId}`);
  console.log('[adminApi] 유저 상세 조회 응답:', res.data);
  return res.data.data;
};


// 유저 승인 상태 업데이트
export const userUpdateApprovalStatus = async (userId, status) => {
  console.log(`[adminApi] 유저 승인 상태 업데이트 API 호출 - userId: ${userId}, status: ${status}`);

  // CSRF 토큰을 확인한 후 요청
   await ensureCsrfToken();

  const res = await api.post(`/api/admin/user/${userId}/userApprovalStatus`, {
    status: status, // 상태 (APPROVED, REJECTED 등)
  }, {
    withCredentials: true,
  });

  console.log('[adminApi] 유저 승인 상태 업데이트 응답:', res.data);
  return res;  // 응답 메시지 또는 상태를 리턴
};

// 유저 정보 수정
export const updateUser = async (userId, userData) => {
  console.log(`[adminApi] 유저 정보 수정 API 호출 - userId: ${userId}`, userData);

  // CSRF 토큰을 확인한 후 요청
  await ensureCsrfToken();

  const res = await api.put(`/api/admin/user/update/${userId}`, userData, {
    withCredentials: true,
  }); // URL 수정

  console.log('[adminApi] 유저 정보 수정 응답:', res.data);
  return res;
};

// 유저 정보 삭제
export const deleteUser = async (userId, password) => {
  console.log(`[adminApi] 유저 정보 삭제 API 호출 - userId: ${userId}`, password);

  await ensureCsrfToken();

  const res = await api.delete(`/api/admin/user/${userId}`, {
    data: { password }, // body에 비밀번호 전달
    withCredentials: true,
  });

  console.log('[adminApi] 유저 정보 삭제 응답:', res.data);
  return res;
};



// 유저 생성 (관리자용)
export const createUserByAdmin = async (userData) => {
  console.log('[adminApi] 어드민 유저 생성 API 호출:', userData);

  await ensureCsrfToken();

  const res = await api.post('/api/admin/user/create', userData, {
    withCredentials: true,
  });

  console.log('[adminApi] 어드민 유저 생성 응답:', res.data);
  return res;
};


// 사용자 정보
export const checkUser = async () => {

  await ensureCsrfToken();

  try {
    const res = await api.get('/api/user/mypage');
    console.log('api checkUser 결과:', res.data)
    return res.data; 
  } catch (error) {
    console.error("checkUser 에러:", error);
    throw error;
  }
};

// 사용자 정보 수정 
export const checkUserEdit = async (data) => {
  await ensureCsrfToken();

  try {
    const res = await api.put('/api/user/mypage', data); // ✅ data 전송 추가
    console.log('api checkUserEdit 결과:', res.data);
    return res.data;
  } catch (error) {
    console.error("checkUserEdit 에러:", error);
    throw error;
  }
};


// 사용자 비밀번호 수정
export const checkUserPasswordEdit = async (data) => {
  await ensureCsrfToken();

  try {
    const res = await api.post('/api/user/change-password', data); // ✅ data 전송 추가
    console.log('api checkUsePasswordEdit 결과:', res.data);
    return res.data;
  } catch (error) {
    console.error("checkUserPasswordEdit 에러:", error);
    throw error;
  }
};
